import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ProjectConfiguration } from '@models/ProjectConfiguration';
import { ProjectTextStyleDirective } from 'src/app/project-text-style.directive';
import { tenDigitsValidator } from '../tenDigitsValidator';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-general',
  imports: [
    CommonModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatCardModule,
    FormsModule,
    ProjectTextStyleDirective,
  ],
  templateUrl: './general.component.html',
  styleUrl: './../project-settings.component.scss'
})
export class GeneralComponent implements OnInit {
  @Input() project!: ProjectConfiguration;
  @Input() formGroup!: FormGroup;
  @Input() resetEvent!: EventEmitter<void>;

  constructor(private fb: FormBuilder) {
  }

  ngOnInit() {
    this.formGroup.addControl('project_title', this.fb.control(this.project.title, Validators.required));
    this.formGroup.addControl('layout_direction', this.fb.control(this.project.layout_direction, Validators.required));
    this.formGroup.addControl('project_description', this.fb.control(this.project.description));
    this.formGroup.addControl('allow_joins', this.fb.control(this.project.allow_joins));
    this.formGroup.addControl('font_families', this.fb.control(this.project.font_families));
    this.formGroup.addControl('font_size', this.fb.control(this.project.font_size));
    this.formGroup.addControl('numerals', this.fb.control(this.project.numerals.join(','), [Validators.required, tenDigitsValidator()]));
    this.formGroup.addControl('gloss_suggestion_mode', this.fb.control(this.project.glossSuggestionMode, Validators.required));

    this.resetEvent.subscribe(() => {
      this.formGroup.get('project_title')?.setValue(this.project.title);
      this.formGroup.get('layout_direction')?.setValue(this.project.layout_direction);
      this.formGroup.get('project_description')?.setValue(this.project.description);
      this.formGroup.get('allow_joins')?.setValue(this.project.allow_joins);
      this.formGroup.get('font_families')?.setValue(this.project.font_families);
      this.formGroup.get('font_size')?.setValue(this.project.font_size);
      this.formGroup.get('numerals')?.setValue(this.project.numerals.join(','));
      this.formGroup.get('gloss_suggestion_mode')?.setValue(this.project.glossSuggestionMode);
    }
    );
  }

  get numerals() {
    return this.formGroup.get('numerals');
  }

  demoChangeNumerals(str: string) {
    const numerals = this.formGroup.get('numerals')?.value.split(',');
    return ProjectConfiguration.performNumeralReplacement(str, numerals);
  }

}
